import { render, staticRenderFns } from "./MultiFilter.vue?vue&type=template&id=54728e9e&scoped=true"
import script from "./MultiFilter.vue?vue&type=script&lang=js"
export * from "./MultiFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54728e9e",
  null
  
)

export default component.exports